//#region libraries
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectExpandAllFlights, setExpandAllFlights } from '_redux/slices/timeline/timeline-control';
import { setExpandedFlights } from '_redux/slices/timeline/flight-information-list';
import { selectUsedTheme } from '_redux/slices/timeline/theme'
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const ExpandAllFlightsSwitch = () => {
    
    //redux
    const dispatch = useDispatch();
    const expandAllFlights = useSelector(selectExpandAllFlights); // status of RampBookings switch
    const usedTheme = useSelector(selectUsedTheme);
    const dbUser = useSelector(selectFirebaseInfo);

    const handleSwitch = () => {
        dispatch(setExpandAllFlights(!expandAllFlights));
        dispatch(setExpandedFlights([]));
    };

    useEffect(() => {
        // if puj user, default expanding flights to none
        if(dbUser?.details?.authority === "PUJ"){
            dispatch(setExpandAllFlights(false))
            dispatch(setExpandedFlights([]));
        }
    }, [dbUser]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Expand All Flights
                </span>
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={expandAllFlights}
                    value={expandAllFlights}
                    style={{ marginLeft: '16px' }}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Expand all flights in the timeline job list, showing all the pre planned passengers tasks.
            </span>
        </div>

    )
}

export default ExpandAllFlightsSwitch
